import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
  // 개발 환경에서만 Stagewise 툴바 초기화
  const loadStagewise = async () => {
    try {
      const { initToolbar } = await import('@stagewise/toolbar');
      
      // 중복 초기화 방지
      if (document.body && document.body.dataset.stagewiseToolbarInitialized === 'true') {
        return;
      }
      if (document.body) {
        document.body.dataset.stagewiseToolbarInitialized = 'true';
      }

      const stagewiseConfig = {
        plugins: []
      };

      initToolbar(stagewiseConfig);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('Stagewise 툴바 로드 실패:', error);
      }
    }
  };

  if (process.env.NODE_ENV === 'development') {
    // DOM이 완전히 로드된 후 툴바 초기화
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadStagewise);
    } else {
      loadStagewise();
    }
  }
